var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/analytics/index.ts
var analytics_exports = {};
__export(analytics_exports, {
  ReferralAnalyticsEvent: () => ReferralAnalyticsEvent,
  ReferralAnalyticsEventsManager: () => ReferralAnalyticsEventsManager,
  getProviderAnalyticsProperties: () => getProviderAnalyticsProperties
});

// src/analytics/provider/getProviderAnalyticsProperties.ts
var parseVimProviderToAnalyticsProvider = (provider) => {
  if (!provider) {
    return void 0;
  }
  const { npi, providerEhrId, demographics, organization } = provider;
  const { firstName, lastName } = demographics ?? {};
  return {
    npi,
    ehr_id: providerEhrId,
    firstName,
    lastName,
    address: organization?.address?.fullAddress
  };
};
var getProviderAnalyticsProperties = (previousProvider, selectedProvider) => {
  return {
    previous_provider: parseVimProviderToAnalyticsProvider(previousProvider),
    selected_provider: parseVimProviderToAnalyticsProvider(selectedProvider)
  };
};

// src/analytics/referral/referralAnalyticsEventsManager.ts
var ReferralAnalyticsEvent = /* @__PURE__ */ ((ReferralAnalyticsEvent2) => {
  ReferralAnalyticsEvent2["BUTTON_CALCULATED"] = "vim_select_button_calculated";
  ReferralAnalyticsEvent2["TARGET_SELECTED_NATIVE"] = "target_selected_native";
  ReferralAnalyticsEvent2["REFERRAL_VIEWED"] = "referral_viewed";
  ReferralAnalyticsEvent2["TARGET_SELECTED_WITH_VIM"] = "target_selected_with_vim";
  ReferralAnalyticsEvent2["VIM_SELECT_BUTTON_CLICKED"] = "vim_select_button_clicked";
  ReferralAnalyticsEvent2["RU_REFERRAL_SUBMITTED"] = "ru_referral_submitted";
  return ReferralAnalyticsEvent2;
})(ReferralAnalyticsEvent || {});
var ReferralAnalyticsEventsManager = class {
  constructor({ trackFunc, logger: loggerParam }) {
    this.track = trackFunc;
    this.logger = loggerParam;
  }
  trackReferralEvent({ event, properties }, referral) {
    const referralProperties = referral ? this.getReferralAnalyticsProperties(referral) : void 0;
    const trackReferralData = {
      event,
      properties: {
        ...properties,
        ...referralProperties
      }
    };
    this.track(trackReferralData);
  }
  getReferralAnalyticsProperties(referral) {
    const { referringProvider, specialty, patient, vimReferralId } = referral;
    const { insurance, vimPatientId } = patient ?? {};
    const { insurer } = insurance ?? {};
    return {
      referringProvider: referringProvider ? this.formatReferringProviderAnalytics(referringProvider) : void 0,
      speciality: specialty,
      insurer,
      vimPatientId,
      referralId: vimReferralId,
      vimReferralId
    };
  }
  formatReferringProviderAnalytics(provider) {
    const { npi, demographics, providerEhrId: id } = provider ?? {};
    const { firstName, lastName } = demographics ?? {};
    return {
      id,
      npi,
      firstName,
      lastName
    };
  }
};

// src/types/osSimulator.ts
var AdapterName = /* @__PURE__ */ ((AdapterName2) => {
  AdapterName2["ALLSCRIPTS"] = "Allscripts";
  AdapterName2["ALLSCRIPTS_DESKTOP"] = "Allscripts Desktop";
  AdapterName2["ATHENA"] = "Athena";
  AdapterName2["CARE360"] = "Care360";
  AdapterName2["DR_CHRONO"] = "Dr-Chrono";
  AdapterName2["DEMO_SDK"] = "demo-sdk";
  AdapterName2["ECW_WEB_ALEDADE"] = "eCW Web Aledade";
  AdapterName2["ECW_WEB_SANITAS"] = "eCW Web Sanitas";
  AdapterName2["ECW_DESKTOP"] = "eCW Desktop";
  AdapterName2["EPIC_DESKTOP"] = "Epic Desktop";
  AdapterName2["ELATION"] = "Elation";
  AdapterName2["E_MEDICAL_PRACTICE"] = "e-medical-practice";
  AdapterName2["KARO"] = "Kareo";
  AdapterName2["NEXTGEN_DESKTOP"] = "NextGen Desktop";
  AdapterName2["OFFICE_ALLY"] = "Office Ally";
  AdapterName2["PRACTICE_FUSION"] = "Practice Fusion";
  AdapterName2["DEFAULT"] = "default";
  AdapterName2["MOCK_EHR"] = "Mock Ehr";
  AdapterName2["MDLAND"] = "MdLand";
  return AdapterName2;
})(AdapterName || {});
var TriggerRequest = /* @__PURE__ */ ((TriggerRequest2) => {
  TriggerRequest2["TRIGGER_OS_SIMULATOR_DATA"] = "trigger_os_simulator_data";
  TriggerRequest2["CLEAR_OS_SIMULATOR_DATA"] = "clear_os_simulator_data";
  TriggerRequest2["TRIGGER_ACTION"] = "trigger_action";
  TriggerRequest2["TRIGGER_WRITEBACK"] = "trigger_writeback";
  TriggerRequest2["TRIGGER_WRITEBACK_V2"] = "trigger_writeback_v2";
  TriggerRequest2["TRIGGER_UI_INJECTION"] = "trigger_ui_injection";
  TriggerRequest2["TOGGLE_EXPAND_WIDGET"] = "toggle_expand_widget";
  TriggerRequest2["RUN_AUTHENTICATED_MONITORS"] = "run_authenticated_monitors";
  TriggerRequest2["TRIGGER_REPORTS_NAMES"] = "trigger_reports_names";
  TriggerRequest2["TRIGGER_REPORT"] = "trigger_report";
  TriggerRequest2["TRIGGER_AUTOMATION"] = "trigger_automation";
  TriggerRequest2["TRIGGER_AUTOMATION_V2"] = "trigger_automation_v2";
  TriggerRequest2["TRIGGER_CAPABILITIES_CONFIG"] = "trigger_capabilities_config";
  TriggerRequest2["TRIGGER_ORGANIZATION_CONFIG"] = "trigger_organization_config";
  TriggerRequest2["TRIGGER_ADAPTER_KPI"] = "trigger_adapter_kpi";
  TriggerRequest2["EXTRACT_ECW_DATA_FOR_OPTUM"] = "extract_ecw_data_for_optum";
  return TriggerRequest2;
})(TriggerRequest || {});
var SendDataToWidgetType = /* @__PURE__ */ ((SendDataToWidgetType2) => {
  SendDataToWidgetType2["OS_SIMULATOR_DATA"] = "os_simulator_data";
  SendDataToWidgetType2["VIM_CONNECT_WIDGET_READY_CHECK"] = "vim-connect-widget-ready-check";
  SendDataToWidgetType2["VIM_CONNECT_WIDGET_READY"] = "vim-connect-widget-ready";
  SendDataToWidgetType2["VIM_CONNECT_RUNTIME_INITIALIZATION_END"] = "vim-connect-runtime-initialization-end";
  SendDataToWidgetType2["EVENT"] = "event";
  SendDataToWidgetType2["STATE"] = "state";
  SendDataToWidgetType2["WINDOW_HANDLE_TRACK"] = "window-handle-track";
  SendDataToWidgetType2["ACTION_RESPONSE"] = "action_response";
  SendDataToWidgetType2["WRITEBACK_RESPONSE"] = "writeback_response";
  SendDataToWidgetType2["WRITEBACK_RESPONSE_V2"] = "writeback_response_v2";
  SendDataToWidgetType2["UI_INJECTION_RESPONSE"] = "ui_injection_response";
  SendDataToWidgetType2["REPORT_NAMES"] = "report_names";
  SendDataToWidgetType2["REPORT"] = "report";
  SendDataToWidgetType2["AUTOMATION_RESPONSE"] = "automation_response";
  SendDataToWidgetType2["AUTOMATION_RESPONSE_V2"] = "automation_response_v2";
  return SendDataToWidgetType2;
})(SendDataToWidgetType || {});
var WritebackProfiler = class {
  constructor(startTime = null, endTime = null, status = null, writebackResponse = null, autoTest = {
    finished: [],
    count: 0,
    fail: 0
  }, resultSum = null, resultRun = null) {
    this.startTime = startTime;
    this.endTime = endTime;
    this.status = status;
    this.writebackResponse = writebackResponse;
    this.autoTest = autoTest;
    this.resultSum = resultSum;
    this.resultRun = resultRun;
  }
};
var EXPECTED_WRITEBACK_RESULTS_OBJECT = {
  v: "1: valid",
  x: "1: invalid",
  vv: "2: valid | valid",
  xx: "2: invalid | invalid",
  vx: "2: valid | invalid",
  xv: "2: invalid | valid",
  vvv: "3: valid | valid | valid",
  xxx: "3: invalid | invalid | invalid",
  vxx: "3: valid | invalid | invalid",
  xvx: "3: invalid | valid | invalid",
  xxv: "3: invalid | invalid | valid",
  vvx: "3: valid | valid | invalid",
  vvvv: "4: valid | valid | valid | valid",
  xxxx: "4: invalid | invalid | invalid | invalid",
  vxxx: "4: valid | invalid | invalid | invalid",
  xvxx: "4: invalid | valid | invalid | invalid",
  xxvx: "4: invalid | invalid | valid | invalid",
  xxxv: "4: invalid | invalid | invalid | valid",
  vvxx: "4: valid | valid | invalid | invalid",
  vxvx: "4: valid | invalid | valid | invalid",
  vxxv: "4: valid | invalid | invalid | valid",
  xvvx: "4: invalid | valid | valid | invalid",
  vvvx: "4: valid | valid | valid | invalid"
};
var DisplayMode = /* @__PURE__ */ ((DisplayMode2) => {
  DisplayMode2["LIGHT"] = "light";
  DisplayMode2["DARK"] = "dark";
  return DisplayMode2;
})(DisplayMode || {});
var SqlSecrets = class {
  constructor(database = "", server = "", user = "", password = "") {
    this.database = database;
    this.server = server;
    this.user = user;
    this.password = password;
  }
};
var OperationType = /* @__PURE__ */ ((OperationType2) => {
  OperationType2["WRITEBACK"] = "writeback";
  OperationType2["UI_INJECTION"] = "ui-injection";
  return OperationType2;
})(OperationType || {});
var AutomationOperationType = /* @__PURE__ */ ((AutomationOperationType2) => {
  AutomationOperationType2["WRITEBACK"] = "writeback" /* WRITEBACK */;
  AutomationOperationType2["UI_INJECTION"] = "ui-injection" /* UI_INJECTION */;
  AutomationOperationType2["ACTION"] = "action";
  AutomationOperationType2["REPORTS"] = "reports";
  return AutomationOperationType2;
})(AutomationOperationType || {});
var OperationResult = /* @__PURE__ */ ((OperationResult2) => {
  OperationResult2["SUCCESS"] = "success";
  OperationResult2["FAILED"] = "failed";
  return OperationResult2;
})(OperationResult || {});
var WritebackVersion = /* @__PURE__ */ ((WritebackVersion2) => {
  WritebackVersion2["V1"] = "v1";
  WritebackVersion2["V2"] = "v2";
  return WritebackVersion2;
})(WritebackVersion || {});
var USE_CASES_OBJECT = {
  duplicateFirst: "Duplicate first",
  duplicateLast: "Duplicate last",
  duplicateCode: "Duplicate code",
  duplicateDescription: "Duplicate description",
  specialCharacters: "Special characters",
  spacesStart: "Spaces start",
  spacesEnd: "Spaces end",
  lowerCase: "Lower case",
  upperCase: "Upper case",
  upperLowerCase: "Upper & lower case",
  cutDescriptionStart: "Cut description start",
  cutDescriptionEnd: "Cut description end",
  addDescriptionStart: "Add description start",
  addDescriptionEnd: "Add description end",
  changeCode: "Change code",
  changeDescription: "Change description",
  removeCode: "Remove code",
  removeDescription: "Remove description",
  reorder: "Reorder"
};
var OptumReportProviderType = /* @__PURE__ */ ((OptumReportProviderType2) => {
  OptumReportProviderType2["CLINIC_PROVIDERS"] = "CLINIC_PROVIDERS";
  OptumReportProviderType2["REFERRED_PROVIDERS"] = "REFERRED_PROVIDERS";
  return OptumReportProviderType2;
})(OptumReportProviderType || {});

// src/vim-connect-ui/types/events.ts
var WidgetOutgoingEvent = /* @__PURE__ */ ((WidgetOutgoingEvent2) => {
  WidgetOutgoingEvent2["ModifyVimConnectUI"] = "vim-connect-ui-modify";
  WidgetOutgoingEvent2["DisplayTooltip"] = "vim-connect-ui-display-tooltip";
  WidgetOutgoingEvent2["DisplayToast"] = "vim-connect-ui-display-toast";
  WidgetOutgoingEvent2["HideTooltip"] = "vim-connect-ui-hide-tooltip";
  WidgetOutgoingEvent2["HideToast"] = "vim-connect-ui-hide-toast";
  WidgetOutgoingEvent2["GetOrganization"] = "GetOrganization";
  WidgetOutgoingEvent2["GetInitialData"] = "vim-connect-ui-get-initial-data";
  WidgetOutgoingEvent2["StoreState"] = "vim-connect-ui-store-state";
  WidgetOutgoingEvent2["AnalyticsTrack"] = "analytics-track";
  WidgetOutgoingEvent2["AnalyticsSetBaseProperties"] = "analytics-set-base-properties";
  WidgetOutgoingEvent2["AnalyticsSetSessions"] = "analytics-set-sessions";
  WidgetOutgoingEvent2["HubWidgetInitialized"] = "vim-connect-ui-hub-widget-initialized";
  WidgetOutgoingEvent2["HubWidgetPositionChanged"] = "vim-connect-ui-hub-widget-position-changed";
  return WidgetOutgoingEvent2;
})(WidgetOutgoingEvent || {});
var WidgetIncomingEvent = /* @__PURE__ */ ((WidgetIncomingEvent2) => {
  WidgetIncomingEvent2["InjectApplication"] = "vim-connect-ui-inject-application";
  WidgetIncomingEvent2["ModifyApplication"] = "vim-connect-ui-modify-application";
  WidgetIncomingEvent2["SelectApplication"] = "vim-connect-ui-select-application";
  WidgetIncomingEvent2["RemoveApplication"] = "vim-connect-ui-remove-application";
  WidgetIncomingEvent2["PatientInContext"] = "vim-connect-ui-patient-in-context";
  WidgetIncomingEvent2["PatientOutContext"] = "vim-connect-ui-patient-out-context";
  WidgetIncomingEvent2["InitData"] = "vim-connect-ui-init-data";
  WidgetIncomingEvent2["Logout"] = "vim-connect-ui-logout";
  WidgetIncomingEvent2["SendDataToWidget"] = "vim-connect-ui-send-data-to-widget";
  WidgetIncomingEvent2["DisplayError"] = "vim-connect-ui-display-error";
  WidgetIncomingEvent2["RecoverError"] = "vim-connect-ui-recover-error";
  WidgetIncomingEvent2["DisplayWriteBackOverlay"] = "vim-connect-ui-display-write-back-overlay";
  WidgetIncomingEvent2["HideWriteBackOverlay"] = "vim-connect-ui-hide-write-back-overlay";
  return WidgetIncomingEvent2;
})(WidgetIncomingEvent || {});

// src/vim-connect-ui/types/toast.ts
var ToastIncomingEventName = /* @__PURE__ */ ((ToastIncomingEventName2) => {
  ToastIncomingEventName2["Display"] = "Display";
  ToastIncomingEventName2["Hide"] = "Hide";
  return ToastIncomingEventName2;
})(ToastIncomingEventName || {});
var ToastOutgoingEventName = /* @__PURE__ */ ((ToastOutgoingEventName2) => {
  ToastOutgoingEventName2["ModifySelf"] = "ModifySelf";
  return ToastOutgoingEventName2;
})(ToastOutgoingEventName || {});

// src/vim-connect-ui/types/tooltip.ts
var TooltipIncomingEventName = /* @__PURE__ */ ((TooltipIncomingEventName2) => {
  TooltipIncomingEventName2["Display"] = "Display";
  TooltipIncomingEventName2["Hide"] = "Hide";
  TooltipIncomingEventName2["InitData"] = "InitData";
  return TooltipIncomingEventName2;
})(TooltipIncomingEventName || {});
var TooltipOutgoingEventName = /* @__PURE__ */ ((TooltipOutgoingEventName2) => {
  TooltipOutgoingEventName2["ModifySelf"] = "ModifySelf";
  TooltipOutgoingEventName2["GetOrganization"] = "GetOrganization";
  return TooltipOutgoingEventName2;
})(TooltipOutgoingEventName || {});

// src/vim-connect-ui/consts/consts.ts
var widgetId = "vim-connect-ui";

// src/vim-connect-ui/utils/positioningUtils.ts
import { Infra } from "@getvim/vim-connect";
var HUB_HEIGHT_MARGIN = 10;
var HUB_WIDTH_MARGIN = 10;
var HUB_WIDTH = 50;
var WRAPPER_HEIGHT_VH = 90;
var EXPANDED_HUB_WRAPPER_TOP_MARGIN = 70;
var APP_BUTTON_EDGE_LENGTH_PIXELS = 50;
var APP_ICON_HEIGHT = 50;
var APP_ICON_WIDTH = 50;
var HUB_SIZE_SHRINK_WIDTH_DESKTOP = 85;
var HUB_SIZE_SHRINK_WIDTH = 60;
var HUB_SIZE_SHRINK_HEIGHT = 65;
var VERTICAL_ARROW_BUTTONS_HEIGHT = 20;
var HORIZONTAL_ARROW_BUTTONS_WIDTH = 25;
var OPENED_HUB_WIDTH = 415;
var CLOSED_HUB_WIDTH = 55;
var TOOLTIP_HEIGHT_PIXELS = 24;
var HUB_HIGH_PERCENT_FROM_TOP = 10;
var HUB_HIGH_MIDDLE_PERCENT_FROM_TOP = 25;
var HUB_MIDDLE_PERCENT_FROM_TOP = 40;
var HUB_LOW_MIDDLE_PERCENT_FROM_BOTTOM = 20;
var HUB_LOW_PERCENT_FROM_BOTTOM = 5;
var lengthToPixelString = (length) => `${length}px`;
var hubPositionEnumToPercent = {
  [Infra.Common.Types.VerticalHubPosition.High]: HUB_HIGH_PERCENT_FROM_TOP,
  [Infra.Common.Types.VerticalHubPosition.High_Middle]: HUB_HIGH_MIDDLE_PERCENT_FROM_TOP,
  [Infra.Common.Types.VerticalHubPosition.Middle]: HUB_MIDDLE_PERCENT_FROM_TOP,
  [Infra.Common.Types.VerticalHubPosition.Low_Middle]: HUB_LOW_MIDDLE_PERCENT_FROM_BOTTOM,
  [Infra.Common.Types.VerticalHubPosition.Low]: HUB_LOW_PERCENT_FROM_BOTTOM
};
function getRightSideClipPath(topVh, menuWidthWithMargin, bottomVh, appsHeightPixels) {
  return `polygon(0% calc(${topVh}vh + ${EXPANDED_HUB_WRAPPER_TOP_MARGIN}px - ${HUB_WIDTH_MARGIN}px), ${menuWidthWithMargin}px calc(${topVh}vh + ${EXPANDED_HUB_WRAPPER_TOP_MARGIN}px - ${HUB_WIDTH_MARGIN}px), ${menuWidthWithMargin}px calc(${topVh}vh - ${HUB_WIDTH_MARGIN}px), 100% calc(${topVh}vh - ${HUB_WIDTH_MARGIN}px), 100% calc(${bottomVh}vh + ${HUB_WIDTH_MARGIN}px), ${menuWidthWithMargin}px calc(${bottomVh}vh + ${HUB_WIDTH_MARGIN}px), ${menuWidthWithMargin}px calc(${topVh}vh + ${appsHeightPixels}px + ${HUB_WIDTH_MARGIN}px), 0% calc(${topVh}vh + ${appsHeightPixels}px + ${HUB_WIDTH_MARGIN}px))`;
}
function getLeftSideClipPath(topVh, menuWidthWithMargin, appsHeightPixels, bottomVh) {
  return `polygon(0% calc(${topVh}vh - ${HUB_WIDTH_MARGIN}px), calc(100% - ${menuWidthWithMargin}px - ${HUB_WIDTH_MARGIN}px) calc(${topVh}vh - ${HUB_WIDTH_MARGIN}px), calc(100% - ${menuWidthWithMargin}px - ${HUB_WIDTH_MARGIN}px) calc(${topVh}vh + ${EXPANDED_HUB_WRAPPER_TOP_MARGIN}px - ${HUB_WIDTH_MARGIN}px), calc(100% + ${HUB_WIDTH_MARGIN}px) calc(${topVh}vh + ${EXPANDED_HUB_WRAPPER_TOP_MARGIN}px - ${HUB_WIDTH_MARGIN}px), calc(100% + ${HUB_WIDTH_MARGIN}px) calc(${topVh}vh + ${appsHeightPixels}px + ${HUB_WIDTH_MARGIN}px), calc(100% - ${menuWidthWithMargin}px - ${HUB_WIDTH_MARGIN}px) calc(${topVh}vh + ${appsHeightPixels}px + ${HUB_WIDTH_MARGIN}px), calc(100% - ${menuWidthWithMargin}px - ${HUB_WIDTH_MARGIN}px) calc(${bottomVh}vh + ${HUB_WIDTH_MARGIN}px), 0% calc(${bottomVh}vh + ${HUB_WIDTH_MARGIN}px))`;
}
var getPositioninPercent = (percent) => {
  return Math.floor(percent / 100 * screen.height);
};
var getClipPath = (numOfApplications, position) => {
  const topVh = (100 - WRAPPER_HEIGHT_VH) / 2;
  const bottomVh = 100 - topVh;
  const menuWidthWithMargin = HUB_WIDTH - HUB_WIDTH_MARGIN;
  const appsHeightPixels = EXPANDED_HUB_WRAPPER_TOP_MARGIN + (numOfApplications + 1) * APP_ICON_HEIGHT;
  const rightSideClipPath = getRightSideClipPath(topVh, menuWidthWithMargin, bottomVh, appsHeightPixels);
  const leftSideClipPath = getLeftSideClipPath(topVh, menuWidthWithMargin, appsHeightPixels, bottomVh);
  const clipPath = position.horizontal === Infra.Common.Types.HorizontalHubPosition.Left ? leftSideClipPath : rightSideClipPath;
  return clipPath;
};
var getPosition = ({
  isShrink,
  isOpen,
  isExpanded,
  numOfApplications,
  position,
  customSize
}, agentType) => {
  const hubHorizontalAlignment = position.horizontal === Infra.Common.Types.HorizontalHubPosition.Left ? { left: "0", right: void 0 } : { right: "0", left: void 0 };
  if (isOpen) {
    const customWidth = customSize?.width ? parseInt(customSize?.width) + HUB_WIDTH : void 0;
    const hubVerticalAlignment2 = { top: "0" };
    const hubAlignment2 = { ...hubHorizontalAlignment, ...hubVerticalAlignment2 };
    return {
      size: {
        width: lengthToPixelString((customWidth ?? OPENED_HUB_WIDTH) + HUB_WIDTH_MARGIN),
        height: "100%"
      },
      alignment: hubAlignment2,
      clipPath: getClipPath(numOfApplications, position)
    };
  }
  const width = isShrink ? agentType === "MSI" ? HUB_SIZE_SHRINK_WIDTH_DESKTOP : HUB_SIZE_SHRINK_WIDTH : APP_ICON_WIDTH + HUB_WIDTH_MARGIN + HORIZONTAL_ARROW_BUTTONS_WIDTH;
  let height = APP_ICON_HEIGHT;
  if (isExpanded || agentType === "MSI") {
    height += numOfApplications * APP_ICON_HEIGHT;
  }
  height += VERTICAL_ARROW_BUTTONS_HEIGHT * 2 + HUB_HEIGHT_MARGIN * 2;
  const verticalAlignment = agentType === "MSI" ? getPositioninPercent(hubPositionEnumToPercent[position.vertical]) : `${hubPositionEnumToPercent[position.vertical]}%`;
  const hubVerticalAlignment = isFromBottom(position.vertical) ? { top: void 0, bottom: `${verticalAlignment}` } : { top: `${verticalAlignment}`, bottom: void 0 };
  const hubAlignment = { ...hubHorizontalAlignment, ...hubVerticalAlignment };
  const heightString = lengthToPixelString(isShrink && !(agentType === "MSI" && isFromBottom(position.vertical)) ? HUB_SIZE_SHRINK_HEIGHT : height);
  return {
    size: {
      width: lengthToPixelString(width),
      height: heightString
    },
    alignment: hubAlignment
  };
};
var getToastPosition = ({
  position,
  customSize,
  shouldAddExtraPaddingToToast
}) => {
  const currentPosition = getPosition({
    isShrink: false,
    isOpen: false,
    isExpanded: false,
    numOfApplications: 1,
    position,
    customSize
  });
  return {
    size: {
      height: currentPosition?.size?.height ?? "50",
      width: currentPosition?.size?.width ?? "100"
    },
    alignment: {
      top: (Number(currentPosition?.alignment?.top ?? 0) + (shouldAddExtraPaddingToToast ? 0 : 20)).toString(),
      ...position.horizontal === Infra.Common.Types.HorizontalHubPosition.Left ? {
        left: (Number(currentPosition.alignment?.left ?? 0) + Number(currentPosition.size?.width?.replace("px", "") ?? 80) - 20).toString()
      } : {
        right: (Number(currentPosition.alignment?.right ?? 0) + Number(currentPosition.size?.width?.replace("px", "") ?? 80) - 20).toString()
      }
    }
  };
};
var isFromBottom = (verticalPosition) => {
  return verticalPosition === Infra.Common.Types.VerticalHubPosition.Low || verticalPosition === Infra.Common.Types.VerticalHubPosition.Low_Middle;
};
var getTooltipVerticalAlignment = (isOpen, hubBottom, appIconBottom, appIconTop, verticalPosition, agentType) => {
  let top;
  let bottom;
  const appIconCenter = (APP_ICON_HEIGHT - TOOLTIP_HEIGHT_PIXELS) / 2;
  if (isOpen) {
    top = `${Math.round(appIconTop + appIconCenter)}`;
  } else if (isFromBottom(verticalPosition)) {
    const distanceFromHubBottom = hubBottom - appIconBottom + appIconCenter;
    bottom = agentType === "MSI" ? Math.round(getPositioninPercent(hubPositionEnumToPercent[verticalPosition]) + distanceFromHubBottom) : `calc(${hubPositionEnumToPercent[verticalPosition]}% + ${distanceFromHubBottom}px)`;
  } else {
    const distanceFromHubTop = appIconTop + appIconCenter;
    top = agentType === "MSI" ? Math.round(getPositioninPercent(hubPositionEnumToPercent[verticalPosition]) + distanceFromHubTop) : `calc(${hubPositionEnumToPercent[verticalPosition]}% + ${distanceFromHubTop}px)`;
  }
  return { top, bottom };
};
var getTooltipHorizontalAlignment = (isOpen, horizontalPosition, customSize) => {
  let right;
  let left;
  const customHubSize = customSize?.width ? parseInt(customSize?.width) + HUB_WIDTH : void 0;
  const hubWidth = isOpen ? customHubSize ?? OPENED_HUB_WIDTH : CLOSED_HUB_WIDTH;
  if (horizontalPosition === Infra.Common.Types.HorizontalHubPosition.Right) {
    right = `${Math.round(hubWidth)}`;
  } else {
    left = `${Math.round(hubWidth)}`;
  }
  return { right, left };
};
var getAppTooltipPosition = ({
  hubPosition,
  boundingClientRect,
  isOpen,
  customSize
}, agentType) => {
  const { horizontal: horizontalPosition, vertical: verticalPosition } = hubPosition;
  const { top: appIconTop, bottom: appIconBottom, hubBottom } = boundingClientRect;
  const { top, bottom } = getTooltipVerticalAlignment(isOpen, hubBottom, appIconBottom, appIconTop, verticalPosition, agentType);
  const { right, left } = getTooltipHorizontalAlignment(isOpen, horizontalPosition, customSize);
  return { top, bottom, right, left };
};

// src/vim-connect-ui/widgets/hubWidget.ts
import { RuntimeContract as RuntimeContract3 } from "@getvim/vim-connect";
import { logger as baseLogger } from "@getvim/vim-connect-logger";
import { setHubPosition } from "@getvim/vim-connect/src/infra/common/api/preferences";
import { listenToRuntimeMessages as listenToRuntimeMessages2 } from "@getvim/vim-connect/src/infra/common/utils";

// src/vimConnectWidget.ts
import { Entities, Errors, Infra as Infra2, RuntimeContract as RuntimeContract2 } from "@getvim/vim-connect";
import { omit, pick } from "lodash-es";
import { logger } from "@getvim/vim-connect-logger";
import {
  flattenBySubstring,
  listenToRuntimeMessages,
  sendMessageToRuntime,
  sendRespondableMessageToRuntime
} from "@getvim/vim-connect/src/infra/common/utils";
import { retry } from "@vim/promise";
var widgetLogger = logger.scope("Vim Connect Widget Infra");
var IncomingRuntimeMessage = RuntimeContract2.Outgoing.OutgoingMessages;
var OutgoingRuntimeMessage = RuntimeContract2.Incoming.IncomingMessages;
var TO_STRING_KEY = "to-string";
var INJECT_WIDGET_TIMEOUT = 30 * 1e3;
var WRITE_BACK_TIMEOUT = 6e4;
var SYNC_MESSAGE_TO_RUNTIME_TIMEOUT = 3e3;
function addWidgetDataListener(id, listener) {
  return listenToRuntimeMessages(IncomingRuntimeMessage.WIDGET_DATA_TO_APP, ({ payload: { payload, widgetId: widgetId2 } }) => {
    if (widgetId2 === id) {
      listener(payload);
    }
  });
}
var WidgetNotInjectedError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "WidgetNotInjectedError";
  }
};
var VimConnectWidget = class {
  constructor(config) {
    this.config = config;
    this.widgetsInitializationMap = /* @__PURE__ */ new Map();
    this.injectWidget = async (counter) => {
      widgetLogger.info("Trying to inject widget", {
        retryNumber: counter,
        widgetId: this.configId,
        injectionId: this.injectionId
      });
      this.sendMessageToRuntime(OutgoingRuntimeMessage.SEND_DATA_TO_WIDGET, {
        widgetId: this.config.id,
        payload: { type: "vim-connect-widget-ready-check" }
      });
      this.sendMessageToRuntime(OutgoingRuntimeMessage.INJECT_WIDGET, {
        widget: this.config
      });
      widgetLogger.info("Waiting for the widget injection to be completed", {
        widgetId: this.configId,
        injectionId: this.injectionId
      });
      try {
        await this.isWidgetInjectedWithTimeout(this.configId);
      } catch (error) {
        widgetLogger.warning("Failed to inject widget", {
          widgetId: this.configId,
          injectionId: this.injectionId,
          error
        });
        throw error;
      }
      widgetLogger.info(`widget injecting completed`, {
        attempts: counter,
        widgetId: this.configId,
        injectionId: this.injectionId
      });
    };
    this.isWidgetInjectedWithTimeout = async (widgetId2) => {
      const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          reject();
        }, INJECT_WIDGET_TIMEOUT);
      });
      const widgetInitPromise = this.widgetsInitializationMap.get(widgetId2);
      await Promise.race([widgetInitPromise, timeoutPromise]);
    };
    this.sendSyncEventResponse = (receivedEvent, responseData, syncEventId) => {
      this.sendEvent(`${String(receivedEvent)}_RESPONSE`, responseData, { syncEventId });
    };
    this.setAnalyticsTrackHandler();
    this.configId = this.config.id;
    this.injectionId = this.config.injectionId;
  }
  writeBackAction(payload, timeout = WRITE_BACK_TIMEOUT) {
    const writebackNoPhiFields = [
      "optumReferralId",
      "targetProvider",
      "specialty",
      "startDate",
      "endDate",
      "priority",
      "diagnosis",
      "numberOfVisits"
    ];
    widgetLogger.info("Write Back Action", {
      noPHI: true,
      payload: pick(payload?.data, writebackNoPhiFields)
    });
    widgetLogger.info("Write Back Action", { payload });
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Errors.WriteBackError("write back timeout"));
      }, timeout);
      sendRespondableMessageToRuntime(RuntimeContract2.Incoming.IncomingMessages.WRITE_BACK, payload).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(new Errors.WriteBackError(error.message));
      }).finally(() => {
        clearTimeout(timer);
      });
    });
  }
  runAction(action, input) {
    widgetLogger.info("Run Action", { action, input });
    return sendRespondableMessageToRuntime(RuntimeContract2.Incoming.IncomingMessages.RUN_ACTION, {
      action,
      input
    });
  }
  addWidgetDataListener(listener) {
    return addWidgetDataListener(this.config.id, listener);
  }
  sendMessageToRuntime(type, payload) {
    return sendMessageToRuntime(type, payload);
  }
  async sendSyncMessageToRuntime(type, payload) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Errors.SyncRuntimeMessageTimeoutError(type, SYNC_MESSAGE_TO_RUNTIME_TIMEOUT));
      }, SYNC_MESSAGE_TO_RUNTIME_TIMEOUT);
      sendRespondableMessageToRuntime(type, payload).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(new Errors.SyncRuntimeMessageFailed(type, error.message));
      }).finally(() => {
        clearTimeout(timer);
      });
    });
  }
  async inject() {
    let isInjectSucceeded = true;
    const startTime = performance.now();
    this.readyPromise = new Promise((resolve) => {
      const removeListener = this.addWidgetDataListener((payload) => {
        if (payload?.type === "vim-connect-widget-ready") {
          resolve();
          if (removeListener)
            removeListener();
        }
      });
    });
    this.widgetsInitializationMap.set(this.configId, this.readyPromise);
    try {
      await retry(this.injectWidget, { retries: 5 });
    } catch (error) {
      widgetLogger.error("Failed to inject the widget for all repeated attempts", {
        widgetId: this.configId,
        injectionId: this.injectionId
      });
      isInjectSucceeded = false;
    } finally {
      const endTime = performance.now();
      widgetLogger.debug("Inject widget execution time:", {
        exectionTime: endTime - startTime,
        isInjectSucceeded,
        widgetId: this.configId
      });
    }
  }
  async modify(modification) {
    this.sendMessageToRuntime(OutgoingRuntimeMessage.MODIFY_WIDGET, {
      widget: { id: this.config.id, ...modification }
    });
  }
  async display() {
    return this.modify({ display: true });
  }
  async hide() {
    return this.modify({ display: false });
  }
  disable(reason) {
    this.modify({ disabled: true, reason, loaded: false });
  }
  enable(reason) {
    this.modify({ disabled: false, reason, loaded: true });
  }
  load() {
    this.modify({ loaded: true });
  }
  async getDeviceId() {
    return this.sendSyncMessageToRuntime(OutgoingRuntimeMessage.DEVICE_ID, void 0);
  }
  addEventListener(event, listener) {
    this.addWidgetDataListener((payload) => {
      if (!payload)
        return;
      const { event: receivedEvent, data } = payload;
      if (receivedEvent === event) {
        listener(data);
      }
    });
  }
  addSyncEventListener(event, callback) {
    this.addWidgetDataListener(async (payload) => {
      if (!payload)
        return;
      const { event: receivedEvent, data, syncEventId } = payload;
      if (receivedEvent === event) {
        const result = await callback(data);
        this.sendSyncEventResponse(event, result, syncEventId);
      }
    });
  }
  async sendEvent(event, data, additionalPayload) {
    if (!this.readyPromise) {
      throw new WidgetNotInjectedError("Cant send data to the widget");
    }
    await this.readyPromise;
    this.sendMessageToRuntime(OutgoingRuntimeMessage.SEND_DATA_TO_WIDGET, {
      widgetId: this.config.id,
      payload: {
        event,
        data,
        ...additionalPayload ? additionalPayload : {}
      }
    });
  }
  async sendData(payload) {
    if (!this.readyPromise) {
      throw new WidgetNotInjectedError("Cant send data to the widget");
    }
    await this.readyPromise;
    this.sendMessageToRuntime(OutgoingRuntimeMessage.SEND_DATA_TO_WIDGET, {
      widgetId: this.config.id,
      payload
    });
  }
  track(data) {
    this.sendMessageToRuntime(OutgoingRuntimeMessage.ANALYTICS_TRACK, data);
  }
  setAnalyticsTrackHandler() {
    const analyticsTrackHandler = (payload) => {
      const { event, properties } = payload;
      const data = {
        event,
        properties: omit(properties, flattenBySubstring(properties, TO_STRING_KEY))
      };
      this.track(data);
    };
    this.addEventListener(Infra2.Apps.VimConnectWidgetOutgoingEventName.TrackAnalyticsData, analyticsTrackHandler.bind(this));
  }
  sendAnalyticsCommonProperties(analyticCommonProperties) {
    this.sendEvent(Infra2.Apps.VimConnectWidgetIncomingEventName.AnalyticsApplicationProperties, analyticCommonProperties);
  }
  initData(payload) {
  }
};
var VimConnectInlineWidget = class extends VimConnectWidget {
  constructor(config) {
    super(config);
  }
};
var VimConnectOverlayWidget = class extends VimConnectWidget {
  constructor(config) {
    super(config);
    this.inject();
  }
};
var VimConnectUIWidget = class extends VimConnectWidget {
  constructor(config) {
    super(config);
    this.setModifyWidgetHandler();
    this.setSelectAppInHubHandler();
    this.setWritebackHandler();
    this.setRunActionHandler();
    this.inject();
  }
  setModifyWidgetHandler() {
    this.addSyncEventListener("ModifyWidget", async (payload) => {
      this.modify(payload);
      return { data: void 0 };
    });
  }
  setSelectAppInHubHandler() {
    this.addSyncEventListener("SelectAppInHub", async () => {
      this.sendMessageToRuntime(OutgoingRuntimeMessage.SELECT_VIM_CONNECT_UI_APP, {
        id: this.config.id,
        expandingType: Entities.UIElements.ExpandingType.AUTOMATIC
      });
      return { data: void 0 };
    });
  }
  setWritebackHandler() {
    this.addSyncEventListener("Writeback", async (payload) => {
      try {
        return { data: await this.writeBackAction(payload) };
      } catch (error) {
        return { error };
      }
    });
  }
  setRunActionHandler() {
    this.addSyncEventListener("RunAction", async ({ type, payload }) => {
      try {
        return { data: await this.runAction(type, payload) };
      } catch (error) {
        return { error };
      }
    });
  }
  async modify(modifications) {
    this.sendMessageToRuntime(OutgoingRuntimeMessage.MODIFY_VIM_CONNECT_UI_APP, {
      id: this.config.id,
      modifications
    });
  }
  async inject() {
    this.readyPromise = new Promise((resolve) => {
      const removeListener = this.addWidgetDataListener((payload) => {
        if (payload?.event === "vim-connect-widget-ready") {
          resolve();
          if (removeListener)
            removeListener();
        }
      });
    });
    this.sendMessageToRuntime(OutgoingRuntimeMessage.INJECT_VIM_CONNECT_UI_APP, this.config);
  }
  async sendEvent(event, data, additionalPayload) {
    if (!this.readyPromise) {
      throw new WidgetNotInjectedError("Cant send data to the widget");
    }
    await this.readyPromise;
    this.sendMessageToRuntime(OutgoingRuntimeMessage.SEND_DATA_TO_WIDGET_VIM_CONNECT_UI_APP, {
      widgetId: this.config.id,
      payload: {
        event,
        data,
        ...additionalPayload ? additionalPayload : {}
      }
    });
  }
};

// src/vim-connect-ui/mocks/applications.ts
var mockApplications = [
  {
    id: "quality-gaps",
    tooltip: "Quality Gaps",
    iframeSource: "https://giphy.com/embed/LTYT5GTIiAMBa"
  },
  {
    id: "health-history",
    tooltip: "Health History",
    iframeSource: "https://giphy.com/embed/mF4k0YXIHDHzy"
  },
  {
    id: "prior-auth",
    tooltip: "Prior Auth",
    iframeSource: "https://giphy.com/embed/tmQrpA8zpG4a16SSxm",
    notifications: 3
  }
];

// src/vim-connect-ui/widgets/hubWidget.ts
import { modifyUrl, overrideEnvConfigQueryParamName } from "@getvim-communication/management";
import { isEqual, pick as pick2 } from "lodash-es";
var logger2 = baseLogger.scope("Hub");
var HubWidget = class extends VimConnectOverlayWidget {
  constructor({
    baseUrl,
    widgetId: widgetId2,
    overrideWidgetsConfig,
    agentType,
    isFullscreen
  }, { displayTooltip, hideTooltip, displayToast, hideToast, storeState }) {
    var __super = (...args) => {
      super(...args);
    };
    if (isFullscreen) {
      __super({
        id: widgetId2,
        url: modifyUrl(baseUrl, { path: "/full-transparent" }),
        display: false,
        transparent: true,
        size: { fullscreen: true, fullscreenSizeReduction: 3 },
        type: "OVERLAY"
      });
    } else {
      __super({
        id: widgetId2,
        url: modifyUrl(baseUrl, { path: "/app" }),
        display: false,
        size: { width: "60", height: "110" },
        alignment: { top: "120", right: "0" },
        type: "OVERLAY"
      });
    }
    this.fullscreen = isFullscreen;
    this.hideToast = hideToast;
    this.hideTooltip = hideTooltip;
    this.displayToast = displayToast;
    this.displayTooltip = displayTooltip;
    this.storeState = storeState;
    this.overrideWidgetsConfig = overrideWidgetsConfig;
    this.agentType = agentType;
    if (!this.fullscreen) {
      this.setModifyVimConnectUIHandler();
      this.setDisplayNotificationsHandlers();
      this.setHideNotificationsHandlers();
    } else {
      this.setHubWidgetReadyHandler();
      this.setHubWidgetPositionChangedHandler();
    }
    this.setHubApplicationEventHandler();
    this.setStoreState();
    this.setGettersListeners();
  }
  setGettersListeners() {
    this.addSyncEventListener("GetOrganization" /* GetOrganization */, async () => this.organization);
    logger2.debug(`Added listener to event ${"GetOrganization" /* GetOrganization */}`);
    this.addSyncEventListener("vim-connect-ui-get-initial-data" /* GetInitialData */, async () => ({
      organization: this.organization,
      hubPosition: this.hubPosition,
      patientsDetails: this.patientsDetails
    }));
    logger2.debug(`Added listener to event ${"vim-connect-ui-get-initial-data" /* GetInitialData */}`);
  }
  addMockData() {
    mockApplications.forEach(this.addApplication.bind(this));
    this.modifyApplication("prior-auth", {});
    this.modifyApplication("care-gaps", { iframeSource: "https://giphy.com/embed/89Eko49m84Ja" });
  }
  async sendMessageToRuntime(type, payload) {
    window.postMessage({ type, payload }, "*");
  }
  sendHubPosition(hubPosition) {
    this.hubPosition = hubPosition;
    setHubPosition(hubPosition).catch((error) => logger2.warning(`Couldn't set hub position`, { error }));
  }
  setModifyVimConnectUIHandler() {
    this.addSyncEventListener("vim-connect-ui-modify" /* ModifyVimConnectUI */, async (payload) => {
      const { vimConnectUiInfo, display } = payload;
      const { position } = vimConnectUiInfo;
      const newHubPosition = pick2(position, ["horizontal", "vertical"]);
      if (newHubPosition && !isEqual(newHubPosition, this.hubPosition)) {
        this.sendHubPosition(newHubPosition);
      }
      const calcHubPosition = getPosition(vimConnectUiInfo, this.agentType);
      this.modify({ ...calcHubPosition, display });
      return calcHubPosition;
    });
  }
  setHubWidgetReadyHandler() {
    this.addEventListener("vim-connect-ui-hub-widget-initialized" /* HubWidgetInitialized */, () => {
      this.modify({
        display: true
      });
    });
  }
  setHubWidgetPositionChangedHandler() {
    this.addEventListener("vim-connect-ui-hub-widget-position-changed" /* HubWidgetPositionChanged */, ({ horizontal, vertical }) => {
      this.sendHubPosition({ horizontal, vertical });
    });
  }
  setDisplayNotificationsHandlers() {
    this.addEventListener("vim-connect-ui-display-tooltip" /* DisplayTooltip */, async (payload) => {
      const { text, vimConnectUiInfo } = payload;
      const { hubPosition } = vimConnectUiInfo;
      const alignment = getAppTooltipPosition(vimConnectUiInfo, this.agentType);
      this.displayTooltip({ text, alignment, hubPosition });
    });
    this.addEventListener("vim-connect-ui-display-toast" /* DisplayToast */, (payload) => {
      const { title, message, html, vimConnectUiInfo } = payload;
      const { alignment } = getToastPosition(vimConnectUiInfo);
      const { text, position: hubPosition } = vimConnectUiInfo;
      const { horizontal: horizontalHubPosition } = hubPosition;
      this.displayToast({
        horizontalHubPosition,
        alignment,
        title,
        message,
        html,
        text
      });
    });
  }
  setHideNotificationsHandlers() {
    this.addEventListener("vim-connect-ui-hide-tooltip" /* HideTooltip */, this.hideTooltip);
    this.addEventListener("vim-connect-ui-hide-toast" /* HideToast */, this.hideToast);
  }
  setStoreState() {
    this.addEventListener("vim-connect-ui-store-state" /* StoreState */, (state) => {
      this.storeState(state);
    });
  }
  setHubApplicationEventHandler() {
    const handlers = {
      [RuntimeContract3.Outgoing.VimConnectUIMessageType.InjectApplication]: (application) => this.addApplication(application),
      [RuntimeContract3.Outgoing.VimConnectUIMessageType.ModifyApplication]: ({
        id,
        modifications
      }) => this.modifyApplication(id, modifications),
      [RuntimeContract3.Outgoing.VimConnectUIMessageType.SelectApplication]: (payload) => this.selectApplication(payload),
      [RuntimeContract3.Outgoing.VimConnectUIMessageType.RemoveApplication]: (id) => this.removeApplication(id),
      [RuntimeContract3.Outgoing.VimConnectUIMessageType.SendDataToWidget]: (payload) => {
        this.sendEvent("vim-connect-ui-send-data-to-widget" /* SendDataToWidget */, payload);
      }
    };
    listenToRuntimeMessages2(RuntimeContract3.Outgoing.OutgoingMessages.DATA_TO_VIM_CONNECT_UI, ({ payload: { payload, type } }) => {
      const handler = handlers[type];
      if (!handler)
        return;
      handler(payload);
    });
  }
  addApplication(application) {
    const url = new URL(application.iframeSource);
    if (this.overrideWidgetsConfig) {
      url.searchParams.set(overrideEnvConfigQueryParamName, JSON.stringify(this.overrideWidgetsConfig));
    }
    this.sendEvent("vim-connect-ui-inject-application" /* InjectApplication */, {
      ...application,
      iframeSource: url.href
    });
    logger2.info("Application has been added!", {
      id: application.id,
      widgetsConfig: this.overrideWidgetsConfig
    });
  }
  modifyApplication(id, modifications) {
    this.sendEvent("vim-connect-ui-modify-application" /* ModifyApplication */, { id, modifications });
    logger2.info("Application has been modified!", { id, modifications });
  }
  selectApplication(payload) {
    this.sendEvent("vim-connect-ui-select-application" /* SelectApplication */, payload);
    logger2.info("Application request to be selected!", payload);
  }
  removeApplication(id) {
    this.sendEvent("vim-connect-ui-remove-application" /* RemoveApplication */, id);
    logger2.info("Application has been removed!", id);
  }
  patientInContext(patient) {
    this.sendEvent("vim-connect-ui-patient-in-context" /* PatientInContext */, patient);
  }
  displayError(error) {
    this.sendEvent("vim-connect-ui-display-error" /* DisplayError */, error);
  }
  recoverError() {
    this.sendEvent("vim-connect-ui-recover-error" /* RecoverError */, void 0);
  }
  displayWriteBackOverlay(config) {
    this.sendEvent("vim-connect-ui-display-write-back-overlay" /* DisplayWriteBackOverlay */, config);
  }
  hideWriteBackOverlay() {
    this.sendEvent("vim-connect-ui-hide-write-back-overlay" /* HideWriteBackOverlay */, void 0);
  }
  patientOutContext() {
    this.sendEvent("vim-connect-ui-patient-out-context" /* PatientOutContext */, void 0);
  }
  initData(payload) {
    this.sendEvent("vim-connect-ui-init-data" /* InitData */, payload);
  }
  handleLogout(isRelogin) {
    if (!isRelogin) {
      this.hide();
    }
    this.sendEvent("vim-connect-ui-logout" /* Logout */, void 0);
  }
};

// src/vim-connect-ui/widgets/toastWidget.ts
import { logger as logger3 } from "@getvim/vim-connect-logger";
import { modifyUrl as modifyUrl2 } from "@getvim-communication/management";
var appLogger = logger3.scope("VimConnectUIToastWidget");
var ToastWidget = class extends VimConnectOverlayWidget {
  constructor(config) {
    const { baseUrl, parentWidgetId } = config;
    super({
      id: `${parentWidgetId}-toast`,
      url: modifyUrl2(baseUrl, { path: "/toast" }),
      display: true,
      ignoreMouseEvents: true,
      size: { width: "100%", height: "100" },
      alignment: { top: "50", right: "50" },
      type: "OVERLAY"
    });
    this.setModifySelfHandler();
  }
  async sendMessageToRuntime(type, payload) {
    window.postMessage({ type, payload }, "*");
  }
  setModifySelfHandler() {
    this.addEventListener("ModifySelf" /* ModifySelf */, async (payload) => {
      this.modify(payload);
    });
  }
  displayToast(payload) {
    this.sendEvent("Display" /* Display */, payload);
  }
  hideToast() {
    this.sendEvent("Hide" /* Hide */, void 0);
  }
  handleLogout() {
    this.hideToast();
  }
};

// src/vim-connect-ui/widgets/tooltipWidget.ts
import { logger as logger4 } from "@getvim/vim-connect-logger";
import { modifyUrl as modifyUrl3 } from "@getvim-communication/management";
var appLogger2 = logger4.scope("VimConnectUITooltipWidget");
var TooltipWidget = class extends VimConnectOverlayWidget {
  constructor(config) {
    const { baseUrl, parentWidgetId } = config;
    super({
      id: `${parentWidgetId}-tooltip`,
      url: modifyUrl3(baseUrl, { path: "/tooltip" }),
      display: true,
      ignoreMouseEvents: true,
      size: { width: "100%", height: "24" },
      alignment: { top: "50", right: "50" },
      type: "OVERLAY"
    });
    this.setModifySelfHandler();
  }
  async sendMessageToRuntime(type, payload) {
    window.postMessage({ type, payload }, "*");
  }
  setModifySelfHandler() {
    this.addEventListener("ModifySelf" /* ModifySelf */, async (payload) => {
      this.modify(payload);
    });
  }
  displayTooltip(payload) {
    this.sendEvent("Display" /* Display */, payload);
  }
  hideTooltip() {
    this.sendEvent("Hide" /* Hide */, void 0);
  }
  initData(payload) {
    this.sendEvent("InitData" /* InitData */, payload);
  }
  handleLogout() {
    this.hideTooltip();
  }
};

// src/vimConnectApp.ts
import { Infra as Infra4, RuntimeContract as RuntimeContract4 } from "@getvim/vim-connect";
import { calculateWidgetEnvUrl } from "@getvim-communication/management";
import { logger as logger5 } from "@getvim/vim-connect-logger";
import logUnhandledErrors from "@getvim/vim-connect/src/infra/common/logUnhandledErrors";
import { setGlobalAccessToken } from "@getvim/vim-connect/src/infra/common/setGlobalAccessToken";
import { setGlobalContext } from "@getvim/vim-connect/src/infra/common/setGlobalContext";
import {
  listenToRuntimeMessages as listenToRuntimeMessages3,
  sendMessageToRuntime as sendMessageToRuntime2,
  sendRespondableMessageToRuntime as sendRespondableMessageToRuntime2
} from "@getvim/vim-connect/src/infra/common/utils";
import { retry as retry2 } from "@vim/promise";
import { isArray, omit as omit2, pick as pick3 } from "lodash-es";
if (!window.location.href.includes("adapters")) {
  logUnhandledErrors("VimConnectApp");
}
var IncomingAppMessage = RuntimeContract4.Outgoing.OutgoingMessages;
var OutgoingAppMessage = RuntimeContract4.Incoming.IncomingMessages;
var INJECT_WIDGET_TIMEOUT2 = 60 * 1e3;
var messagesToFilter = [
  "Failed to fetch",
  "Extension context invalidated.",
  "Event listener failed",
  "chrome runtime is not available, unable to send message of type",
  "You have temporarily exceeded your Sumo Logic quota"
];
var VimConnectApp = class {
  constructor(_state) {
    this._state = _state;
    this.listenersMap = /* @__PURE__ */ new Map();
    this.productName = "";
    this.adapterName = "";
    this.products = [];
    this.widgetsInitializationMap = /* @__PURE__ */ new Map();
    this.widgetInitializationResolveMap = /* @__PURE__ */ new Map();
    this.stateEffects = [];
    this.iframeSource = "";
    this.isWidgetInjectedWithTimeout = async (widgetId2) => {
      const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          reject(new Error(`Reached timeout of ${INJECT_WIDGET_TIMEOUT2}ms`));
        }, INJECT_WIDGET_TIMEOUT2);
      });
      const widgetInitPromise = this.widgetsInitializationMap.get(widgetId2);
      await Promise.race([widgetInitPromise, timeoutPromise]);
    };
    this.appLogger = logger5.scope(`App Infra: ${this.getName()}`);
    this.appLogger.debug("Start app initialization", { noPHI: true });
    this.initialized = new Promise((resolve) => {
      listenToRuntimeMessages3(IncomingAppMessage.INITIALIZE_DATA, async ({ payload }) => {
        try {
          await this.initializeAppData(payload);
          resolve();
          this.appLogger.info("App initialized successfully", { noPHI: true });
        } catch (error) {
          if (this.shouldFilter(error?.message)) {
            return;
          }
          this.appLogger.error("App failed to initialize", {
            error,
            payload: this.filterKeysFromObject(payload, ["password"]),
            app: this.getName()
          });
          throw error;
        }
      });
    });
    listenToRuntimeMessages3(IncomingAppMessage.SEND_EVENT, async ({ payload: sendEventPayload }) => {
      const { eventName, payload, id } = sendEventPayload;
      const callbacks = this.listenersMap.get(eventName);
      await this.initialized;
      await Promise.all(callbacks?.map(async (callback) => {
        this.appLogger.info("calling event handler", { noPHI: true, eventName });
        try {
          await callback({ id, payload, state: this._state });
        } catch (error) {
          if (this.shouldFilter(error?.message)) {
            return;
          }
          this.appLogger.error("Event listener failed", {
            error,
            payload: omit2(payload, ["password"]),
            app: this.getName(),
            eventName,
            id
          });
        }
      }) ?? []);
    });
    listenToRuntimeMessages3(IncomingAppMessage.WIDGET_DATA_TO_APP, async (message) => {
      const {
        payload: { payload, widgetId: widgetId2 }
      } = message;
      const { type } = payload;
      if (type === Infra4.Apps.WidgetPayloadType.WIDGET_READY) {
        const resolve = this.widgetInitializationResolveMap.get(widgetId2);
        if (resolve) {
          resolve();
          this.appLogger.info("widget is ready", { noPHI: true, widgetId: widgetId2 });
          this.widgetInitializationResolveMap.delete(widgetId2);
        }
        return;
      }
      if (type === "vim-connect-widget-analytics-track") {
        const { event, properties } = payload;
        this.track({ event, properties: omit2(properties, "to-string") });
        return;
      }
      try {
        await this.onWidgetData(message);
      } catch (error) {
        this.appLogger.error("Error happened on widget data", {
          error,
          payload,
          app: this.getName(),
          widgetId: widgetId2
        });
      }
    });
    listenToRuntimeMessages3(IncomingAppMessage.UPDATE_ACCESS_TOKEN, ({ payload }) => {
      const { accessToken } = payload;
      if (accessToken && this.workspaceConfig) {
        this.appLogger.info("Load new access token globally", { noPHI: true });
        setGlobalAccessToken(accessToken);
        this.workspaceConfig.accessToken = accessToken;
        this.handleAccessTokenChanged(accessToken);
      } else {
        this.appLogger.info("Empty access token received, did not update");
      }
    });
    listenToRuntimeMessages3(IncomingAppMessage.SET_LOGGER_USER_METADATA, async ({ payload }) => {
      try {
        const { userMetadata } = payload;
        this.appLogger.info("App setting userMetadata", { userMetadata });
        logger5.setUserMetadata(userMetadata);
      } catch (error) {
        this.appLogger.warning("App failed to set userMetadata", {
          error,
          payload,
          app: this.getName()
        });
      }
    });
    this.initializeApp();
  }
  async initializeAppData(data) {
    const {
      adapterName,
      state,
      workspaceConfig,
      adapterConfig,
      applicationConfig,
      organizationConfig,
      products,
      publishedEventsState,
      vimConnectUser,
      pubsubId,
      runtimeId
    } = data;
    this.appLogger.debug("Start initializeAppData in VimConnectApp", {
      adapterName,
      workspaceConfig: omit2(workspaceConfig, ["salt"]),
      adapterConfig,
      applicationConfig,
      organizationConfig,
      products,
      publishedEventsState,
      vimConnectUser,
      pubsubId,
      runtimeId
    });
    this.workspaceConfig = workspaceConfig;
    const { accessToken, deviceId, version, activeWindow, overrideWidgetsConfig } = workspaceConfig ?? {};
    if (this.getName() !== Infra4.Common.Consts.VIM_CONNECT_UI_APP_NAME) {
      setGlobalContext({ deviceId, adapterName, version, windowId: activeWindow?.id });
    }
    if (accessToken)
      setGlobalAccessToken(accessToken);
    let iframeSource = "";
    try {
      const iframeSourceBaseUrl = new URL(await calculateWidgetEnvUrl(this.productName, overrideWidgetsConfig));
      if (accessToken) {
        iframeSourceBaseUrl.searchParams.append("initialAccessToken", accessToken);
      }
      iframeSource = iframeSourceBaseUrl.href;
    } catch (e) {
      this.appLogger.info("Failed to calculate iframeSource for VimConnectApp", {
        productName: this.productName,
        error: e
      });
    }
    this.adapterConfig = adapterConfig;
    this.adapterName = adapterName;
    this.applicationConfig = applicationConfig;
    this.organizationConfig = organizationConfig;
    this.products = products;
    this.vimConnectUser = vimConnectUser;
    this.pubsubId = pubsubId;
    this.runtimeId = runtimeId;
    this.iframeSource = iframeSource;
    this.setState(state);
    await this.onInitializedAppData();
    this.handleAccessTokenChanged(accessToken);
    publishedEventsState && this.triggerListenersByPublishedEventsState(publishedEventsState);
  }
  getSourceOfProduct(product) {
    return this.products?.find(({ name }) => name === product)?.sources?.[0];
  }
  getSourcesOfProduct(product) {
    return this.products?.find(({ name }) => name === product)?.sources;
  }
  async initializeApp() {
    await this.onInitialize();
    this.sendMessageToRuntime(OutgoingAppMessage.APP_INITIALIZED, {
      applicationName: this.productName
    });
  }
  async sendMessageToRuntime(type, payload) {
    return sendMessageToRuntime2(type, payload);
  }
  listenToEvent(eventName, callback) {
    const currentCallbacks = this.listenersMap.get(eventName);
    const newCallbacks = callback instanceof Array ? callback : [callback];
    const callbacks = currentCallbacks ? [...currentCallbacks, ...newCallbacks] : newCallbacks;
    this.listenersMap.set(eventName, callbacks);
    if (!currentCallbacks) {
      this.sendMessageToRuntime(OutgoingAppMessage.LISTEN_TO_EVENT, { eventName });
    }
  }
  async sendDataToWidget({ widgetId: widgetId2, payload }) {
    this.appLogger.debug("Send data to the widget is waiting", {
      noPHI: true,
      widgetId: widgetId2,
      payload: omit2(payload, ["payload.credentials", "payload.payload.credentials"])
    });
    await this.widgetsInitializationMap.get(widgetId2);
    await this.sendMessageToRuntime(OutgoingAppMessage.SEND_DATA_TO_WIDGET, { widgetId: widgetId2, payload });
    this.appLogger.debug("Sending the data to the widget was successful", {
      noPHI: true,
      widgetId: widgetId2,
      payload: omit2(payload, ["payload.credentials", "payload.payload.credentials"])
    });
  }
  removeWidget(widgetId2) {
    this.sendMessageToRuntime(OutgoingAppMessage.REMOVE_WIDGET, { widgetId: widgetId2 });
  }
  async injectWidget(injectWidgetPayload) {
    let isInjectSucceeded = true;
    const startTime = performance.now();
    const {
      widget: { id: widgetId2, injectionId }
    } = injectWidgetPayload;
    this.appLogger.info("Start injecting widget process", { noPHI: true, widgetId: widgetId2, injectionId });
    const promise = new Promise((resolvePromise) => {
      this.widgetInitializationResolveMap.set(widgetId2, resolvePromise);
    });
    this.widgetsInitializationMap.set(widgetId2, promise);
    try {
      await retry2(async (counter) => {
        this.appLogger.info("Trying to inject widget", {
          retryNumber: counter,
          widgetId: widgetId2,
          url: injectWidgetPayload.widget.url,
          injectionId
        });
        this.sendMessageToRuntime(OutgoingAppMessage.INJECT_WIDGET, injectWidgetPayload);
        this.sendMessageToRuntime(OutgoingAppMessage.SEND_DATA_TO_WIDGET, {
          widgetId: widgetId2,
          payload: { type: "vim-connect-widget-ready-check" }
        });
        this.appLogger.info("Waiting for the widget injection to be completed", {
          widgetId: widgetId2,
          injectionId
        });
        try {
          await this.isWidgetInjectedWithTimeout(widgetId2);
        } catch (err) {
          this.appLogger.warning("Failed to inject widget", { widgetId: widgetId2, injectionId, err });
          throw err;
        }
        this.appLogger.info("widget injecting completed", { widgetId: widgetId2, injectionId });
      }, { retries: 5 });
    } catch (error) {
      this.appLogger.error("Failed to inject the widget for all repeated attempts", {
        widgetId: widgetId2,
        injectionId
      });
      isInjectSucceeded = false;
    } finally {
      const endTime = performance.now();
      this.appLogger.debug("Inject widget execution time:", {
        exectionTime: endTime - startTime,
        isInjectSucceeded,
        widgetId: widgetId2
      });
    }
  }
  modifyWidget(payload) {
    this.sendMessageToRuntime(OutgoingAppMessage.MODIFY_WIDGET, payload);
  }
  async writeBackAction(payload) {
    const writebackNoPhiFields = [
      "optumReferralId",
      "targetProvider",
      "specialty",
      "startDate",
      "endDate",
      "priority",
      "diagnosis",
      "numberOfVisits"
    ];
    this.appLogger.info("Write Back Action", {
      noPHI: true,
      payload: pick3(payload?.data, writebackNoPhiFields)
    });
    this.appLogger.info("Write Back Action", { payload });
    return sendRespondableMessageToRuntime2(OutgoingAppMessage.WRITE_BACK, payload);
  }
  runAction(action, input) {
    this.appLogger.info("Run Action", { action, input });
    return sendRespondableMessageToRuntime2(OutgoingAppMessage.RUN_ACTION, {
      action,
      input
    });
  }
  track(data) {
    this.sendMessageToRuntime(OutgoingAppMessage.ANALYTICS_TRACK, data);
  }
  async onInitialize() {
  }
  async onInitializedAppData() {
  }
  handleAccessTokenChanged(accessToken) {
  }
  get state() {
    return this._state;
  }
  shouldFilter(message) {
    return messagesToFilter.some((filteredError) => message?.includes(filteredError));
  }
  filterKeysFromObject(payload, keysToFilter) {
    try {
      return JSON.parse(JSON.stringify(payload, (key, value) => keysToFilter.includes(key) ? "filtered from log" : value));
    } catch (error) {
      this.appLogger.warning("Failed to parse payload object on initialize", {
        error,
        keysToFilter
      });
      return payload;
    }
  }
  persistToStorage(data) {
    Object.entries(data).forEach(([key, value]) => this.sendMessageToRuntime(OutgoingAppMessage.STORAGE_SET, {
      key,
      value
    }));
  }
  testStateDependenciesChange(changes, deps) {
    return deps.some((dep) => dep in changes && changes[dep] !== this.state[dep]);
  }
  setState(payload, persist = false) {
    if (!payload)
      return;
    const activatedEffects = this.stateEffects.filter(({ deps }) => this.testStateDependenciesChange(payload, deps)).map(({ effect }) => effect);
    Object.assign(this._state, payload);
    activatedEffects.forEach((effect) => effect());
    if (persist) {
      this.persistToStorage(payload);
    }
  }
  addStateEffect(effect, deps) {
    const stateEffect = { effect, deps };
    this.stateEffects.push(stateEffect);
  }
  triggerListenersByPublishedEventsState(publishedEventsState) {
    Object.entries(publishedEventsState).forEach(([event, collectedPayloads]) => this.listenersMap.get(event)?.forEach((callback) => {
      this.appLogger.info("Triggering listener for published event(s)", {
        event,
        payload: collectedPayloads
      });
      if (isArray(collectedPayloads)) {
        collectedPayloads.forEach((payload) => callback({ payload }));
      } else {
        callback({ payload: collectedPayloads });
      }
    }));
  }
};

// src/vimConnectUIApp.ts
import { RuntimeContract as RuntimeContract5 } from "@getvim/vim-connect";
import { logger as baseLogger2 } from "@getvim/vim-connect-logger";
import { calculateWidgetEnvUrl as calculateWidgetEnvUrl2 } from "@getvim-communication/management";
var logger6 = baseLogger2.scope("Vim Connect UI App");
var VimConnectUIApp = class extends VimConnectApp {
  constructor() {
    super({});
    this.isLoggedIn = false;
    this.isFullScreen = false;
    logger6.info("Vim Connect UI has started");
  }
  async initializeAppData(data) {
    this.organizationId = data.organizationId;
    return super.initializeAppData(data);
  }
  async onInitializedAppData() {
    const { overrideWidgetsConfig = {}, agentType, agentVersion } = this.workspaceConfig || {};
    this.isFullScreen = true;
    const baseUrl = await calculateWidgetEnvUrl2(widgetId, overrideWidgetsConfig);
    this.hubWidget = new HubWidget({
      baseUrl,
      widgetId,
      overrideWidgetsConfig,
      agentType,
      isFullscreen: this.isFullScreen
    }, {
      displayTooltip: this.displayTooltip.bind(this),
      hideTooltip: this.hideTooltip.bind(this),
      displayToast: this.displayToast.bind(this),
      hideToast: this.hideToast.bind(this),
      storeState: this.storeState.bind(this)
    });
    this.listenToEvents();
    if (this.isFullScreen) {
      this.tooltipWidget = new Proxy({}, {
        get(_target, property) {
          return () => {
            logger6.info("tooltip widget is not supported in fullscreen mode", {
              property
            });
          };
        }
      });
      this.toastWidget = new Proxy({}, {
        get(_target, property) {
          return () => {
            logger6.warning("toast widget is not supported in fullscreen mode", {
              property
            });
          };
        }
      });
    } else {
      this.tooltipWidget = new TooltipWidget({
        baseUrl,
        parentWidgetId: widgetId
      });
      this.toastWidget = new ToastWidget({ baseUrl, parentWidgetId: widgetId });
    }
    logger6.info("All widgets initialized", {
      fullscreenMode: this.isFullScreen
    });
  }
  async initializeApp() {
    this.sendMessageToRuntime(RuntimeContract5.Incoming.IncomingMessages.APP_INITIALIZED, {
      applicationName: widgetId
    });
    await this.onInitialize();
  }
  listenToEvents() {
    this.listenersMap.clear();
    this.listenToEvent("corruptedEhrState", this.handleEhrError.bind(this));
    this.listenToEvent("patientInContext", this.patientInContext.bind(this));
    this.listenToEvent("patientOutOfContext", this.patientOutContext.bind(this));
  }
  patientOutContext() {
    if (!this.isLoggedIn)
      return;
    this.hubWidget.patientOutContext();
  }
  patientInContext({ payload }) {
    if (!this.isLoggedIn)
      return;
    const patient = payload;
    if (!patient) {
      logger6.warning("Got event patientInContext without patient!");
      return;
    }
    this.hubWidget.patientInContext(patient);
  }
  displayHub() {
    this.hubWidget.display();
  }
  hideHub() {
    this.hubWidget.hide();
  }
  displayWriteBackOverlay(config) {
    return this.hubWidget.displayWriteBackOverlay(config);
  }
  hideWriteBackOverlay() {
    return this.hubWidget.hideWriteBackOverlay();
  }
  displayTooltip(payload) {
    this.tooltipWidget.displayTooltip(payload);
  }
  hideTooltip() {
    this.tooltipWidget.hideTooltip();
  }
  displayToast(payload) {
    this.toastWidget.displayToast(payload);
  }
  hideToast() {
    this.toastWidget.hideToast();
  }
  initializeData(payload) {
    this.isLoggedIn = true;
    const { hubPosition, organization, user, patientsDetails } = payload;
    this.tooltipWidget.initData({ organization });
    this.setState({ user });
    this.hubWidget.initData({
      hubPosition,
      organization,
      user,
      patientsDetails: patientsDetails?.[user?.linkedEhrUser ?? ""],
      products: payload.products
    });
  }
  storeState(patientsDetails) {
    const state = { patientsDetails: { [this.state.user?.linkedEhrUser ?? ""]: patientsDetails } };
    this.setState(state, true);
  }
  async sendMessageToRuntime(type, payload) {
    window.postMessage({ type, payload }, "*");
  }
  handleEhrError({ payload }) {
    if (!this.isLoggedIn)
      return;
    if (!payload || !payload?.properties) {
      logger6.warning("Got event without payload!");
      return;
    }
    const { error, recover } = payload.properties;
    if (recover)
      this.hubWidget.recoverError();
    else
      this.hubWidget.displayError(error ?? "General Error");
  }
  async onWidgetData() {
  }
  getName() {
    return "vim-connect-ui";
  }
  handleLogout(isRelogin) {
    this.isLoggedIn = false;
    this.hubWidget?.handleLogout(isRelogin);
    this.tooltipWidget?.handleLogout();
    this.toastWidget?.handleLogout();
    this.listenToEvents();
  }
};

// src/genericRuntimeApp.ts
import { logger as logger7 } from "@getvim/vim-connect-logger";
import { calculateWidgetUrl } from "@getvim/vim-connect/src/infra/apps/utils";
var genericAppLogger = logger7.scope("Generic Runtime App");
var GenericRuntimeApp = class extends VimConnectApp {
  constructor(applicationId, friendlyName, envToUrl) {
    super();
    this.applicationId = applicationId;
    this.friendlyName = friendlyName;
    this.envToUrl = envToUrl;
    this.productName = applicationId;
    this.runtimeToWidget("patientInContext", WidgetEvent.PatientInContext);
    this.runtimeToWidget("patientOutOfContext", WidgetEvent.PatientOutOfContext);
    this.runtimeToWidget("patientChartOpened", WidgetEvent.PatientChartOpened);
    this.runtimeToWidget("patientChartClosed", WidgetEvent.PatientChartClosed);
    this.runtimeToWidget("encounterStart", WidgetEvent.EncounterStart);
    this.runtimeToWidget("encounterUpdated", WidgetEvent.EncounterUpdated);
    this.runtimeToWidget("encounterExit", WidgetEvent.EncounterExit);
    this.runtimeToWidget("referralViewed", WidgetEvent.ReferralViewed);
    this.runtimeToWidget("referralClosed", WidgetEvent.ReferralClosed);
  }
  async onInitializedAppData() {
    const iframeSource = await calculateWidgetUrl(this.productName, this.envToUrl, this.workspaceConfig?.overrideWidgetsConfig);
    const config = {
      productConfig: this.products.find((p) => p.name === this.productName),
      organizationConfig: this.organizationConfig,
      adapterConfig: this.adapterConfig,
      workspaceConfig: this.workspaceConfig
    };
    this.widgetConnector = new GenericHubWidget({
      iframeSource,
      applicationId: this.applicationId,
      friendlyName: this.friendlyName,
      config
    });
    genericAppLogger.info(`${this.applicationId} is running on ${iframeSource}`);
  }
  runtimeToWidget(runtimeEventName, widgetEventName) {
    this.listenToEvent(runtimeEventName, ({ payload }) => {
      this.widgetConnector.sendToWidget(widgetEventName, payload);
    });
  }
  handleAccessTokenChanged(accessToken) {
    this.widgetConnector.sendToWidget(WidgetEvent.AccessTokenChanged, accessToken);
  }
  onWidgetData() {
  }
  getName() {
    return this.applicationId;
  }
};
var GenericHubWidget = class extends VimConnectUIWidget {
  constructor({
    iframeSource,
    applicationId,
    friendlyName,
    config
  }) {
    super({
      id: applicationId,
      iframeSource,
      tooltip: friendlyName,
      type: "VIM_CONNECT_UI_TAB",
      disabled: true
    });
    this.sendEvent(WidgetEvent.Init, config);
  }
  sendToWidget(eventName, data) {
    return this.sendEvent(eventName, data);
  }
};
var WidgetEvent = /* @__PURE__ */ ((WidgetEvent2) => {
  WidgetEvent2["Init"] = "Init";
  WidgetEvent2["AccessTokenChanged"] = "AccessTokenChanged";
  WidgetEvent2["PatientInContext"] = "PatientInContext";
  WidgetEvent2["PatientOutOfContext"] = "PatientOutOfContext";
  WidgetEvent2["PatientChartOpened"] = "PatientChartOpened";
  WidgetEvent2["PatientChartClosed"] = "PatientChartClosed";
  WidgetEvent2["EncounterStart"] = "EncounterStart";
  WidgetEvent2["EncounterUpdated"] = "EncounterUpdated";
  WidgetEvent2["EncounterExit"] = "EncounterExit";
  WidgetEvent2["ReferralViewed"] = "ReferralViewed";
  WidgetEvent2["ReferralClosed"] = "ReferralClosed";
  return WidgetEvent2;
})(WidgetEvent || {});
export {
  APP_BUTTON_EDGE_LENGTH_PIXELS,
  APP_ICON_HEIGHT,
  APP_ICON_WIDTH,
  AdapterName,
  analytics_exports as Analytics,
  AutomationOperationType,
  DisplayMode,
  EXPANDED_HUB_WRAPPER_TOP_MARGIN,
  EXPECTED_WRITEBACK_RESULTS_OBJECT,
  GenericRuntimeApp,
  HUB_HEIGHT_MARGIN,
  HUB_SIZE_SHRINK_HEIGHT,
  HUB_SIZE_SHRINK_WIDTH,
  HUB_SIZE_SHRINK_WIDTH_DESKTOP,
  HUB_WIDTH,
  HUB_WIDTH_MARGIN,
  HubWidget,
  OperationResult,
  OperationType,
  OptumReportProviderType,
  SendDataToWidgetType,
  SqlSecrets,
  ToastIncomingEventName,
  ToastOutgoingEventName,
  ToastWidget,
  TooltipIncomingEventName,
  TooltipOutgoingEventName,
  TooltipWidget,
  TriggerRequest,
  USE_CASES_OBJECT,
  VimConnectApp,
  VimConnectInlineWidget,
  VimConnectOverlayWidget,
  VimConnectUIApp,
  VimConnectUIWidget,
  WRAPPER_HEIGHT_VH,
  WidgetIncomingEvent,
  WidgetOutgoingEvent,
  WritebackProfiler,
  WritebackVersion,
  getAppTooltipPosition,
  getPosition,
  getToastPosition,
  hubPositionEnumToPercent,
  widgetId
};
//# sourceMappingURL=index.js.map
